<div
  class="wrapper"
  *ngIf="generalTechnicalInfoForm"
  [formGroup]="generalTechnicalInfoForm"
>
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="
        getErrors(insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE)
      "
      style="color: red"
    >
      warning
    </mat-icon>
    <span
      i18n="
        @@survey.inside.technicalinfo.inside.general.technicalinfo.introduction"
      >Introduction</span
    >
  </div>
  <div class="section question-section">
    <div class="questions">
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red; margin-right: 0.5rem"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.INTRODUCTION_FIELD
              )
            "
            >warning
          </mat-icon>
        </div>
        <app-technical-info-question
          [question]="'Introduction'"
          formControlName="introduction"
          [options]="technicalInfoQuestionIntroductionOptions"
          [displayError]="
            getErrors(
              insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
              insideSurveyInsideInfo.INTRODUCTION_FIELD
            )
          "
        ></app-technical-info-question>
      </div>
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.QUADRANT_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.quadrant"
            >Quadrant</span
          >
        </div>
        <div class="btnContainer">
          <span
            class="chipBtn clickable"
            [class.disabled]="!isAuthCanWrite"
            [class.active]="getCurrentQuadrant() === option.value"
            *ngFor="let option of quadrantType"
            (click)="onChangeQuadrantValue(option.value)"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.QUADRANT_FIELD
              )
            }"
            >{{ option.label }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="additionalQuestionsVisible" class="section question-section">
    <div class="questions">
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUMBER_GUTTERS_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.cable.gutters"
            >Cable protection gutters</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfGutters"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUMBER_GUTTERS_FIELD
              )
            }"
          />

          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.cable.meter"
            >m</span
          >
        </div>
      </div>
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_90_DEGREE_CORNERS_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.corner.pieces"
            >90° corner pieces</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOf90DegreeCorners"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_90_DEGREE_CORNERS_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>

      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_INSIDE_OUTSIDE_CORNERS_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.corner.pieces.insideoutside"
            >Inside/outside corner pieces</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfInsideOutsideCorners"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_INSIDE_OUTSIDE_CORNERS_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_ENDKITS_GUTTERS_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.cable.gutters.endkits"
            >End kits for cable gutters</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfEndKitsForGutters"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_ENDKITS_GUTTERS_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>
    </div>
    <div class="questions">
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_HORIZONTAL_DRILLING_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.drillings.horizontal"
            >Horizontal drillings</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfHorizontalDrilling"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_HORIZONTAL_DRILLING_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_VERTICAL_DRILLING_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.drillings.vertical"
            >Vertical drillings</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfVerticalDrilling"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_VERTICAL_DRILLING_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_SEALING_KITS_DRILLING_HOLES_FIELD
              )
            "
            >warning
          </mat-icon>
          <span
            class="question required-answer"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.questions.sealingkits"
            >Sealing kits for wall/floor drillingholes</span
          >
        </div>
        <div class="input-wrapper">
          <input
            class="form-control"
            type="number"
            min="0"
            step="1"
            (change)="formatInt($event)"
            formControlName="nrOfSealingKitsForDrillingHoles"
            [ngClass]="{
              'invalid-answer-input': getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.NUM_SEALING_KITS_DRILLING_HOLES_FIELD
              )
            }"
          />
          <span
            class="question addendum"
            i18n="
              @@survey.inside.technicalinfo.inside.general.technicalinfo.answer.pieces"
            >pieces</span
          >
        </div>
      </div>
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red; margin-right: 0.5rem"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
                insideSurveyInsideInfo.SELLING_HIGHER_THAN_3_5_FIELD
              )
            "
            >warning
          </mat-icon>
        </div>
        <app-technical-info-question
          class="half-width"
          [question]="
            'Scaffold is required for installation (seilings higher than 3,5m)'
          "
          formControlName="sellingHigherThan3and5m"
          [options]="technicalInfoQuestionsBoolOptions"
          [displayError]="
            getErrors(
              insideSurveyInsideInfo.GENERAL_TECHNICAL_INFO_INTRO_SUBTITLE,
              insideSurveyInsideInfo.SELLING_HIGHER_THAN_3_5_FIELD
            )
          "
        >
        </app-technical-info-question>
      </div>
    </div>
  </div>
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="
        getErrors(insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE)
      "
      style="color: red"
    >
      warning
    </mat-icon>
    <span
      i18n="
        @@survey.inside.technicalinfo.inside.general.technicalinfo.section.horizontalinfo.title"
      >Horizontal & vertical info
    </span>
  </div>
  <div class="section question-section">
    <div class="questions">
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
                insideSurveyInsideInfo.HORIZONTAL_TECHNICAL_SHAFT_FIELD
              )
            "
            >warning
          </mat-icon>
        </div>
        <app-technical-info-question
          [question]="'Horizontal technical shaft'"
          formControlName="horizontalTechnicalShaft"
          [options]="technicalInfoQuestionsBoolOptions"
          [displayError]="
            getErrors(
              insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
              insideSurveyInsideInfo.HORIZONTAL_TECHNICAL_SHAFT_FIELD
            )
          "
        >
        </app-technical-info-question>
      </div>
    </div>
    <div class="questions">
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
                insideSurveyInsideInfo.VERTICAL_SHAFT_FIELD
              )
            "
            >warning
          </mat-icon>
        </div>
        <app-technical-info-question
          [question]="'Vertical technical shaft'"
          formControlName="verticalTechnicalShaft"
          [options]="technicalInfoQuestionsBoolOptions"
          [displayError]="
            getErrors(
              insideSurveyInsideInfo.HORIZONTAL_VERTICAL_INFO_SUBTITLE,
              insideSurveyInsideInfo.VERTICAL_SHAFT_FIELD
            )
          "
        ></app-technical-info-question>
      </div>
    </div>
  </div>
  <div class="section" *ngIf="verticalTechnicalShaft">
    <div
      style="display: flex; align-items: center; gap: 0.5rem"
      class="sub-title required-answer"
    >
      <mat-icon
        *ngIf="getErrors(insideSurveyInsideInfo.VERTICAL_PHOTO_SUBTITLE)"
        style="color: red"
      >
        warning
      </mat-icon>
      <span
        class="required"
        i18n="
          @@survey.inside.technicalinfo.inside.general.technicalinfo.section.vertical.photo"
        >Vertical Technical Shaft Photo
      </span>
    </div>
    <app-photo-and-remark
      class="full-width"
      [limit]="10"
      [surveyId]="survey.id"
      [isAuthCanWrite]="isAuthCanWrite"
      [photos]="pictures.generalTechnicalInfoPhotos"
      [isInsidePhoto]="true"
      [camera]="camera"
      [cameraLayer]="cameraLayer"
      [surveyType]="surveyType.Inside"
      [surveyPhotoType]="surveyPhotoType.GeneralTechnicalInfoPhoto"
      [remarkFieldName]="generalPhotoRemarkFieldName"
      componentDescriptionTitle="Vertical Image"
    ></app-photo-and-remark>
  </div>
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="getErrors(insideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE)"
      style="color: red"
    >
      warning
    </mat-icon>
    <span
      i18n="
        @@survey.inside.technicalinfo.inside.general.technicalinfo.section.electrictyandother.title"
      >Electricity & Other Info
    </span>
  </div>
  <div class="section question-section">
    <div class="questions">
      <div class="form-line">
        <app-technical-info-question
          [question]="'Electricity in Telco Room'"
          formControlName="electricityInTelcoRoom"
          [options]="technicalInfoQuestionsBoolOptions"
          [isRequired]="false"
        ></app-technical-info-question>
      </div>
    </div>
    <div class="questions">
      <div class="form-line">
        <div class="question subtitle-wrapper">
          <mat-icon
            style="color: red; margin-right: 0.5rem"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE,
                insideSurveyInsideInfo.ROOM_AVAILABLE_FUTURE_INTRO_BOX_FIELD
              )
            "
            >warning
          </mat-icon>
        </div>
        <app-technical-info-question
          [question]="'Room available for new equipment'"
          formControlName="roomAvailableForFutureIntroBox"
          [options]="technicalInfoQuestionsBoolOptions"
          [displayError]="
            getErrors(
              insideSurveyInsideInfo.ELECTRICITY_OTHER_INFO_SUBTITLE,
              insideSurveyInsideInfo.ROOM_AVAILABLE_FUTURE_INTRO_BOX_FIELD
            )
          "
        >
        </app-technical-info-question>
      </div>
    </div>
  </div>
  <ng-container *ngIf="isElectricityInTelcoRoom || isRoomAvailable">
    <!-- <div
      class="sub-title"
      i18n="
        @@survey.inside.technicalinfo.inside.general.technicalinfo.section.electrictyandequipment.title"
    >
      Electricity and Equipment
    </div> -->
    <div
      style="display: flex; align-items: center; gap: 0.5rem"
      class="sub-title required"
    >
      <mat-icon
        *ngIf="getErrors(insideSurveyInsideInfo.ELECTRICITY_PHOTO_SUBTITLE)"
        style="color: red"
      >
        warning
      </mat-icon>
      <span
        i18n="
          @@survey.inside.technicalinfo.inside.general.technicalinfo.section.electricity.photo"
        >Electricity & Other Info Photo
      </span>
    </div>
    <div class="section photo-section">
      <app-photo-and-remark
        *ngIf="isElectricityInTelcoRoom"
        [limit]="1"
        [surveyId]="survey.id"
        [isAuthCanWrite]="isAuthCanWrite"
        [photos]="pictures.electricityInTelcoRoomPhotos"
        [isInsidePhoto]="true"
        [camera]="camera"
        [cameraLayer]="cameraLayer"
        [surveyType]="surveyType.Inside"
        [surveyPhotoType]="surveyPhotoType.ElectricityInTelcoRoom"
        [remarkFieldName]="electricityInTelcoRoomPhotoRemarkFieldName"
        componentDescriptionTitle="Electricity Telco Room"
        [sideBySide]="isRoomAvailable"
      ></app-photo-and-remark>
      <app-photo-and-remark
        *ngIf="isRoomAvailable"
        [limit]="1"
        [surveyId]="survey.id"
        [isAuthCanWrite]="isAuthCanWrite"
        [photos]="pictures.roomAvailableForNewEquipmentPhotos"
        [isInsidePhoto]="true"
        [camera]="camera"
        [cameraLayer]="cameraLayer"
        [surveyType]="surveyType.Inside"
        [surveyPhotoType]="surveyPhotoType.RoomAvailableForNewEquipment"
        [remarkFieldName]="roomAvailableForNewEquipmentPhotoRemarkFieldName"
        componentDescriptionTitle="Equipment Telco Room"
        [sideBySide]="isElectricityInTelcoRoom"
      ></app-photo-and-remark>
    </div>
  </ng-container>
  <div
    class="sub-title"
    i18n="
      @@survey.inside.technicalinfo.inside.general.technicalinfo.telcoroom.otherremarks"
  >
    Other Telco room remarks
  </div>
  <div class="section remarks-section">
    <textarea
      [readonly]="!this.isAuthCanWrite"
      placeholder="add remarks"
      formControlName="otherTelcoRemarks"
      maxlength="300"
    ></textarea>
  </div>
</div>
